import { render, staticRenderFns } from "./orderReturnDetail2.vue?vue&type=template&id=7407af88&"
import script from "./orderReturnDetail2.vue?vue&type=script&lang=js&"
export * from "./orderReturnDetail2.vue?vue&type=script&lang=js&"
import style0 from "./orderReturnDetail2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports